import { useAction } from '@reatom/npm-react'
import { useState } from 'react'

import { toggleFavoritePairAction } from '../atoms'

import type { Pair } from '@root/entities/pair'

export const useFavorite = () => {
  const [blocked, setBlocked] = useState(false)

  const toggleFavoritePair = useAction(toggleFavoritePairAction)

  const toggleFavorite = (pair: Pair.PairMinimal) => {
    if (blocked) {
      return
    }

    setBlocked(true)
    toggleFavoritePair({ pair })
    setTimeout(() => setBlocked(false), 1000)
  }

  return { toggleFavorite }
}
